import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

export const localState = Vue.observable({ from: {}, to: {} });

const routes = [
    {
        path: '/',
        component: () => import('../views/projects/projects'),
        name: 'home'
    },
    {
        path: '/archive',
        component: () => import('../views/projects/projects-archive'),
        name: 'archive'
    },
    {
        path: '/video-chat/:url',
        component: () => import('../views/video-chat/video-chat-container'),
        props: true,
        name: 'video-chat'
    },
    {
        path: '/calendar',
        component: () => import('../views/calendar/calendar.vue'),
        props: true,
        name: 'calendar'
    },
    {
        path: '/create-vacancy',
        component: () => import('../views/create-vacancy/create-vacancy')
    },
    {
        path: '/edit-vacancy/:vacancy_id',
        component: () => import('../views/edit-vacancy/edit-vacancy'),
        props: true
    },
    {
        path: '/education',
        component: () => import('../views/education/education')
    },
    {
        path: '/education/:url',
        component: () => import('../views/education/module'),
        props: true,
        children: [
            {
                path: ':id',
                component: () => import('../views/education/lesson'),
                props: true
            }
        ]
    },
    {
        path: '/chat',
        component: () => import('../views/chat')
    },
    {
        name: 'hunt',
        path: '/hunt/:vacancy_id/:status_id?',
        component: () => import('../views/hunt/hunt1.vue'),
        props: true
    },
    {
        name: 'hired',
        path: '/hired',
        component: () => import('../views/hired'),
        props: true
    },
    {
        path: '/vacancy/:vacancy_id',
        component: () => import('../views/vacancy'),
        props: true
    },
    {
        path: '/applicant/:id/:status_id?',
        component: () => import('../views/applicant'),
        props: true,
        name: 'applicant'
    },
    {
        path: '/project/:id',
        component: () => import('../views/projects/mob/projectVacanciesMob'),
        props: true
    },
    {
        path: '/tasks',
        component: () => import('../views/tasks/tasks.vue'),
    },
    {
        path: '/support',
        component: () => import('../views/support/support.vue'),
        children: [
            {
                path: 'list',
                component: () => import('../views/support/appeals-list.vue'),
                name: 'list'
            },
            {
                path: 'new',
                component: () => import('../views/support/new-appeal.vue'),
                name: 'new'
            },
        ]
    },
    {
        path: '/pay',
        component: () => import('../views/pay/pay'),
        children: [
            {
                path: 'subscribe',
                component: () => import('../views/pay/subscribe.vue'),
                meta: { notSubscribe: true }
            },
            {
                path: 'payer',
                meta: { notSubscribe: true },
                component: () => import('../views/pay/payer/payer.vue'),
            },
            {
                path: 'payments',
                meta: { notSubscribe: true },
                component: () => import('../views/pay/payments'),
            }
        ]
    },
    {
        path: '/hunt-requests',
        component: () => import('../views/hunt-requests'),
        children: [
            {
                path: 'forms',
                component: () => import('../views/hunt-requests/hunt-forms')
            },
            {
                path: 'forms/:form_id',
                component: () => import('../views/hunt-requests/hunt-form-show'),
                props: true
            },
            {
                path: 'requests',
                component: () => import('../views/hunt-requests/hunt-requests.vue'),
            },
            {
                path: 'requests/:request_id',
                component: () => import('../views/hunt-requests/hunt-request-show'),
                props: true
            },
        ]
    },
    {
        path: '/settings',
        component: () => import('../views/settings/settings'),
        name: 'settings',
        children: [
            {
                path: 'subscribe',
                component: () => import('../views/pay/pay.vue'),
                children: [
                    {
                        path: 'info',
                        component: () => import('../views/pay/info.vue'),
                        name: 'info'
                    },
                    {
                        path: 'pay',
                        component: () => import('../views/pay/subscribe.vue'),
                        name: 'pay'
                    },
                    {
                        path: 'payments',
                        component: () => import('../views/pay/payments.vue'),
                        name: 'payments'
                    }
                ]
            },
            {
                path: 'profile',
                component: () => import('../views/settings/profile/profile'),
            },
            {
                path: 'apps',
                component: () => import('../views/settings/apps'),
            },
            {
                path: 'users',
                component: () => import('../views/settings/users/users'),
            },
            {
                path: 'chrome-ext-btn',
                component: () => import('../views/settings/chrome-ext-btn'),
            },
            {
                path: 'interaction',
                component: () => import('../views/settings/interaction/interaction.vue'),
                children: [
                    {
                        path: 'interactive-tags',
                        component: () => import('../views/settings/interaction/tags.vue'),
                        name: 'interactive-tags'

                    },
                    {
                        path: 'interactive-buttons',
                        component: () => import('../views/settings/interaction/interactive-buttons.vue'),
                        name: 'interactive-buttons'

                    },
                    {
                        path: 'interactive-statuses',
                        component: () => import('../views/settings/interaction/interactive-statuses.vue'),
                        name: 'interactive-statuses'

                    }
                ]
            },
            {
                path: 'notifications',
                component: () => import('../views/settings/notifications/notifications'),
            },
            {
                path: 'questionnaire',
                component: () => import('../views/settings/questionnaire/questionnaire-all'),
            },
            {
                path: 'questionnaire/:questionnaire_id',
                component: () => import('../views/settings/questionnaire/questionnaire-show'),
                props: true
            },
            {
                path: 'messages',
                component: () => import('../views/settings/messages/messages')
            },
            {
                path: 'voice-messages',
                component: () => import('../views/settings/voice-messages/voice-messages.vue')
            },
            {
                path: 'community',
                component: () => import('../views/settings/community.vue'),
            },
        ],
    },
    {
        path: '/analytics',
        component: () => import('../views/analytics/analytics')
    },
    //авторизация и регистрация
    {
        path: '/login',
        component: () => import('../views/login/login'),
        name: 'login',
    },
    {
        path: '/forgot-password',
        component: () => import('../views/login/forgot-password'),
        name: 'forgot-password',
    },
    {
        path: '/registration',
        component: () => import('../views/login/registration'),
        name: 'registration',
    },
    {
        name: 'enter-contacts',
        path: '/enter-contacts',
        component: () => import('../views/login/enter-contacts')
    },
    {
        name: 'link-vk',
        path: '/link-vk',
        component: () => import('../views/login/link-vk')
    },
    {
        name: 'send-goals-registration',
        path: '/send-goals/registration',
        component: () => import('../views/login/send-goals-registration')
    },
    {
        name: 'send-goals-pay',
        path: '/send-goals/pay',
        component: () => import('../views/login/send-goals-pay')
    },
    {
        path: '/messages',
        component: () => import('../views/messages/messages-container')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: '/office',
    routes,
    scrollBehavior (to, from, savedPosition) {
        Vue.set(localState, 'from', from);
        Vue.set(localState, 'to', to);
        // Exists when Browser's back/forward pressed
        if (savedPosition) {
            return savedPosition
            // For anchors
        } else if (to.hash) {
            return { selector: to.hash }
        } else if (from.path === to.path) {
            return {}
        } else {
            const match_routes = /\/hunt\//i
            if(to.path.match(match_routes)) return {}
            // Scroll to top
            return { x: 0, y: 0 }
        }

    }
})

router.beforeEach((to, from, next) => {
    store.commit('setMobWidth')
    // store.commit('setFunction', {name: 'router', payload: {from, to}})
    return next()
});

export default router
